export const paymentTypes = {
    AUTOPAY: 'autopay',
    ONCE: 'oneTime',
    PAYOFF: 'payoff',
    PENDING: 'pending'
};
export const paymentOptions = {
    CURRENT_BALANCE: 'currentBalanceOption',
    FIXED_PAYMENT: 'fixedPaymentAmountOption',
    MINIMUM_PAYMENT_DUE: 'totalMinimumPaymentOption',
    MONTHLY_FIXED_PAYMENT_AMOUNT: 'monthlyFixedPaymentAmountOption',
    MONTHLY_NEXT_AMOUNT_DUE: 'monthlyNextAmountDueOption',
    MONTHLY_PAYMENT: 'monthlyPaymentOption',
    OTHER_PAYMENT: 'otherAmountOption',
    PAST_DUE: 'pastDueAmountOption',
    PN4_FIXED_PAYMENT_AMOUNT: 'pn4FixedPaymentAmountOption',
    PN4_NEXT_AMOUNT_DUE: 'pn4NextAmountDueOption',
    SECURED_INSTALLMENT_FIXED_PAYMENT_AMOUNT: 'securedInstallmentFixedPaymentAmountOption',
    SECURED_INSTALLMENT_MONTHLY_PAYMENT_AMOUNT: 'securedInstallmentMonthlyPaymentOption',
    STATEMENT_BALANCE: 'statementBalanceOption',
    TOTAL_AMOUNT_DUE: 'totalAmountDueOption',
    WAIVED_INTEREST_AUTOPAY_AMOUNT: 'waivedInterestAutopayAmountOption',
    WAIVED_INTEREST_ONE_TIME_AMOUNT: 'waivedInterestOneTimeAmountOption'
};
